<template>

    <div class="animated fadeIn align-middle">

        <b-card id="content" class="bg-white">

            <b-row>

                <b-col class="col-2">
                    <b-img src="img/ata.png" fluid alt="Logo de ATA Cloud"></b-img>
                </b-col>

                <b-col class="align-self-center">
                    <h2>ATA AUTÓNOMOS | Encuesta de satisfacción</h2>
                </b-col>

            </b-row>

            <b-row class="mt-4" v-if="step > 0 && step < 6">
                <b-col>
                    Pregunta {{step}} de 5
                </b-col>
            </b-row>

            <intro v-if="step === 0" @initSurvey="nextStep"></intro>
            <attention-question v-if="step === 1" v-model="survey.attention"></attention-question>
            <knowledge-question v-if="step === 2" v-model="survey.knowledge"></knowledge-question>
            <resolution-question v-if="step === 3" v-model="survey.resolution"></resolution-question>
            <satisfaction-question v-if="step === 4" v-model="survey.satisfaction"></satisfaction-question>
            <comments-question v-if="step === 5" v-model="survey.comments"></comments-question>
            <contact-question v-if="step === 6" v-model="survey.contact"></contact-question>

            <b-row class="text-center mt-4"  v-if="step === 7">
                <b-col>
                    <h3>ENCUESTA ENVIADA CORRECTAMENTE</h3>
                    <h4>Puede cerrar esta ventana</h4>
                </b-col>
            </b-row>

            <b-row class="mt-4" v-if="step > 0 && step < 5">
                <b-col>
                    <button v-if="step > 1" @click="previousStep" class="btn btn-secondary mr-2">ANTERIOR</button>
                    <button :disabled="!validate()" @click="nextStep" class="btn btn-primary">SIGUIENTE</button>
                </b-col>
            </b-row>

            <b-row class=" mt-4" v-if="step === 5">
                <b-col>
                    <button @click="previousStep" class="btn btn-secondary mr-2">ANTERIOR</button>
                    <button @click="nextStep" class="btn btn-primary">FINALIZAR</button>
                </b-col>
            </b-row>

            <b-row class=" mt-4" v-if="step === 6">
                <b-col>
                    <button @click="previousStep" class="btn btn-secondary mr-2">ANTERIOR</button>
                    <button :disabled="loading" @click="sendSurvey" class="btn btn-primary">ENVIAR</button>
                    <loading class="ml-2 float-right" v-if="loading"></loading>
                </b-col>
            </b-row>

        </b-card>

    </div>
    
</template>

<script>
    import Intro from "./Intro";
    import AttentionQuestion from "./AttentionQuestion";
    import KnowledgeQuestion from "./KnowledgeQuestion";
    import ResolutionQuestion from "./ResolutionQuestion";
    import SatisfactionQuestion from "./SatisfactionQuestion";
    import CommentsQuestion from "./CommentsQuestion";
    import ContactQuestion from "./ContactQuestion";
    import {createQueryRating} from "@/api/query-rating-api";

    export default {
        name: "QuerySurvey",

        components: {
            Intro,
            AttentionQuestion,
            KnowledgeQuestion,
            ResolutionQuestion,
            SatisfactionQuestion,
            CommentsQuestion,
            ContactQuestion
        },

        data: function () {
            return {
                step: 0,
                survey: {
                    attention: null,
                    knowledge: null,
                    resolution: null,
                    satisfaction: null,
                    comments: null,
                    contact: false,
                },
                loading: false
            }
        },

        methods: {

            nextStep() {
                if (this.step < 6) {
                    this.step++;
                }
            },

            previousStep() {
                if (this.step > 1) {
                    this.step--;
                }
            },

            validate() {
                if (
                    this.step === 1
                    &&
                    this.survey.attention
                ) {
                    return true;
                }
                if (
                    this.step === 2
                    &&
                    this.survey.knowledge
                ) {
                    return true;   
                }
                if (
                    this.step === 3
                    &&
                    this.survey.resolution
                ) {
                    return true;
                }
                if (
                    this.step === 4
                    &&
                    this.survey.satisfaction
                ) {
                    return true;
                }
            },

            sendSurvey() {
                this.loading = true;
                let token = this.$route.query.token;
                createQueryRating(
                    token,
                    this.survey.attention,
                    this.survey.knowledge,
                    this.survey.resolution,
                    this.survey.satisfaction,
                    this.survey.comments,
                    this.survey.contact
                )
                    .then(() => {
                        this.loading = false;
                        this.step = 7;
                    })
                    .catch((error) => {
                        this.loading = false;
                        if (error.response.data === 'Query rating token has expired') {
                            this.$_notificationMixin_error("La encuesta ha expirado", "La fecha límite para poder valorar la respuesta a su consulta ha pasado");
                        } else {
                            this.$_notificationMixin_error("Error al enviar la encuesta", "Se ha producido un error al enviar la encuesta");
                        }
                    })
            }
        },
    }
</script>

<style scoped>

    #content {
        width: 60%;
        margin: 100px auto;
    }

</style>